import { Box, Link, Typography, styled } from '@mui/material';
import { FC, ReactNode, MouseEventHandler } from 'react';

import { Link as RouterLink } from 'react-router-dom';

const TagsGridItemImage = styled('img')`
  width: 100%;
  aspect-ratio: 1/1;
  transition: opacity 0.3s ease-in-out;
  &:hover {
    opacity: 0.7;
  }
`;

type TagsGridHeaderProps = { children: ReactNode; id: string };

export const TagsGridHeader = ({ children, id }: TagsGridHeaderProps) => (
  <Typography
    variant="h3"
    marginBottom={2}
    sx={{ fontSize: { xs: 16, sm: 24 }, fontWeight: { xs: 100, sm: 900 } }}
    id={id}
  >
    {children}
  </Typography>
);

type TagsGridProps = { children: ReactNode };

export const TagsGrid = ({ children }: TagsGridProps) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: {
        xs: 'repeat(12, 35vw)',
        sm: 'repeat(12, 12rem)',
        md: 'repeat(4, 1fr)',
        lg: 'repeat(6, 1fr)',
      },
      gridGap: {
        xs: 10,
        sm: '1rem',
        md: '2rem',
      },
      overflowX: 'auto',
      paddingBottom: 5,
    }}
  >
    {children}
  </Box>
);

export const TagsGridItemLabel: FC = ({ children }) => (
  <Typography
    data-testid="featured-genre-label"
    fontSize={16}
    lineHeight="24px"
  >
    {children}
  </Typography>
);

interface TagsGridItemProps {
  image: string;
  redirectionPath: string;
  onClick?: MouseEventHandler;
}

export const TagsGridItem: FC<TagsGridItemProps> = ({
  children,
  image,
  redirectionPath,
  onClick,
}) => (
  <Link
    component={RouterLink}
    to={redirectionPath}
    underline="hover"
    color="inherit"
    onClick={onClick}
  >
    <TagsGridItemImage src={image} />
    {children}
  </Link>
);
